const TOKEN_KEY = 'pocket.token';
const URL_KEY = 'pocket.hub_url';

export function getHubUrl(): string {
  const stored = localStorage.getItem(URL_KEY);
  if (stored && stored.trim()) return stored.replace(/\/$/, '');
  const env = import.meta.env.VITE_POCKET_HUB_URL as string | undefined;
  if (env && env.trim()) return env.replace(/\/$/, '');
  return 'http://localhost:8787';
}

export function setHubUrl(url: string): void {
  localStorage.setItem(URL_KEY, url.replace(/\/$/, ''));
}

export function getToken(): string {
  return localStorage.getItem(TOKEN_KEY) || '';
}

export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY);
}

export function isConfigured(): boolean {
  return Boolean(getToken());
}
